import { stats } from '@/mocks/home';

export default function StatsSection() {
  return (
    <section className="w-full px-4 md:px-6 py-14 bg-accent-500">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8">
          {stats.map((stat) => (
            <div key={stat.label} className="flex flex-col items-center text-center">
              <div className="w-12 h-12 flex items-center justify-center mb-3">
                <i className={`${stat.icon} text-3xl text-white`}></i>
              </div>
              <span className="text-3xl md:text-4xl font-bold text-white mb-2 font-heading">
                {stat.value}
              </span>
              <span className="text-sm text-white/80">{stat.label}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}